module.exports = __webpack_public_path__ + "static/media/fourthareaproduct1.7e659f4d.jpg";